import React, { Component } from 'react'
import { Link, useHistory } from 'react-router-dom';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import Select from "react-select";
import Loading from '../../common/Loading'
import CurrencyInput from 'react-currency-input-field';
import moment from "moment";

const tipos = [
    { label: "Lavar/Passa", value: "1" },
    { label: "Lavar", value: "2" },
    { label: "Passar", value: "3" },
  ];

class Comissao extends Component {

    constructor(props){
        super(props);

        this.state = {
            items: [],
            filtros:[],
            itensRow:[],
            isListagem:true,
            isEdicao: false,
            id:'',          
            tipo:'',
            pessoa:'',
            servico:'',
            comissoa:'',
            inicio:'',
            fim: '',
            
        }

        this.add = this.add.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.cancel = this.cancel.bind(this);
        this.atualiza = this.atualiza.bind(this);
        this.handleFiltroGrid = this.handleFiltroGrid.bind(this);

    }

    async Loading(isLoading) {
        this.setState({ isLoading: isLoading });
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');
        const grupo     = sessionStorage.getItem('grupo');       
        this.Loading(true)
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 23 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('VER') < 0 ) return this.props.history.push('/index') 
        
        
        await api.get('/api/comissao', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {  
            this.Loading(false)         
            this.setState( { items : response.data, filtros: response.data} );
        })
        this.Loading(false)
    }

    add = async(item) => {

           
        const token    = sessionStorage.getItem('token');        
        const grupo     = sessionStorage.getItem('grupo');       
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 23 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
   
        const servicos = await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        });

        let servico = [];
        servicos.data.forEach(element => {
            servico.push({value: element.id, label:element.nome })
        });

        const pessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        });

        let pessoa = [];
        pessoas.data.forEach(element => {
            pessoa.push({value: element.id, label:element.razao })
        });
        
        this.setState({
            isListagem: false, 
            isEdicao:true,
            tipo:'',
            tipos: tipos,
            tiposDefault:[],
            pessoa:'',
            pessoas:pessoa,
            pessoasDefault:[],
            servico:'',
            servicos:servico,
            servicosDefault:[],
            comissoa:'',
            inicio:'',
            fim:''         
        })

    }

    edit = async( id ) => {
        
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return value.idmenu  == 23 })
        if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
     
        const servicos = await api.get('/api/servico', {
            headers: {
                'x-access-token':token,
            }
        });
        
       
        const pessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        });

       

        try {

            await api.get(`/api/comissao/${id}`, {
                headers: {
                    'x-access-token':token,
                }
            }).then(response => {

                let servico = [];
                let servicoDefault = []
                servicos.data.forEach(element => {
                    if(response.data.servico ==  element.id )  servicoDefault.push({value: element.id, label:element.nome })
                    servico.push({value: element.id, label:element.nome })
                });

                let pessoa = [];
                let pessoaDefault = []
                pessoas.data.forEach(element => {
                    if(response.data.pessoa == element.id)pessoaDefault.push({value: element.id, label:element.razao })
                    pessoa.push({value: element.id, label:element.razao })
                });

                              

                this.setState({
                    isListagem: false, 
                    isEdicao:true,
                    id:response.data.id,
                    tipo:response.data.tipo,
                    tipos: tipos,
                    tiposDefault:response.data.tipo == 1 ? [{ label: "Lavar/Passa", value: "1" }] : response.data.tipo == 2 ? [{ label: "Lavar", value: "2" }] : [ { label: "Passar", value: "3" }],
                    pessoa:response.data.pessoa,
                    pessoas:pessoa,
                    pessoasDefault:pessoaDefault,
                    servico:response.data.servico,
                    servicos:servico,
                    servicosDefault:servicoDefault,
                    comissao:response.data.comissao,
                    inicio: response.data.inicio ? moment(response.data.inicio).format('YYYY-MM-DD') : null,
                    fim:response.data.fim ? moment(response.data.fim).format('YYYY-MM-DD') : null                     
                })      
            });

        } catch (error) {
            this.alert(error)       
        }
    }

    cancel = (item) => {
        const token    = sessionStorage.getItem('token');
       
        api.get('/api/comissao', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                tipo:'',
                tipos: tipos,
                tiposDefault:[],
                pessoa:'',
                pessoas:'',
                pessoasDefault:[],
                servico:'',
                servicos:'',
                servicosDefault:[],
                comissoa:'',
                inicio:'',
                fim:'',     
                items : response.data    
            })
        })     

    }

    save = async (event) => {
        event.preventDefault();
        const { id, tipo, pessoa, servico, comissao, inicio, fim } = this.state
        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return  value.idmenu  == 23 })
        
        
        try {
            
            if ( id ) {
     
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('ALTERAR') < 0 ) return toast.error('O usuário sem permissão.') 
     
        
                await api.put(`/api/comissao/${id}`,{ tipo, pessoa, servico, comissao, inicio, fim }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/comissao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            tipo:'',
                            tipos: tipos,
                            tiposDefault:[],
                            pessoa:'',
                            pessoas:pessoa,
                            pessoasDefault:[],
                            servico:'',
                            servicos:servico,
                            servicosDefault:[],
                            comissoa:'',
                            inicio:'',
                            fim:'',                          
                            items : response.data
                
                        });
                       
                    })
                })
            } else {
                if(empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('INSERIR') < 0 ) return toast.error('O usuário sem permissão.') 
     
                await api.post('/api/comissao',{ id, tipo, pessoa, servico, comissao, inicio, fim }, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then( async response => {
                    const grupo = response.data.id
                    await api.get('/api/comissao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {           
                        toast.success("Registro salvo.");                        
                        
                        this.setState({
                            isListagem: true, 
                            isEdicao:false,
                            tipo:'',
                            tipos: tipos,
                            tiposDefault:[],
                            pessoa:'',
                            pessoas:pessoa,
                            pessoasDefault:[],
                            servico:'',
                            servicos:servico,
                            servicosDefault:[],
                            comissoa:'',
                            inicio:'',
                            fim:'',     
                            items : response.data
                
                        });
                    })
                   
                })
            }
        } catch (error) {
            toast.error(error)            
        }
        
    }

    delete = async (id) => {

        const grupo     = sessionStorage.getItem('grupo');       
        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });       

        const empresaGrupo        = permissoes.data.filter(function(value){ return  value.idmenu  == 23 })
        if( empresaGrupo.length > 0 && empresaGrupo[0].permissao.indexOf('EXCLUIR') < 0 ) return toast.error('O usuário sem permissão.') 
        
        
        try {
            
            if ( window.confirm(`Confirma deleção do registro ${id}?`)) {
            
                await api.delete(`/api/comissao/${id}`, {
                    headers: {
                        'x-access-token':token,
                    }
                }).then(response => {
                    api.get('/api/comissao', {
                        headers: {
                            'x-access-token':token,
                        }
                    }).then(response => {
                        this.setState( { items : response.data } );
                        toast.error(<i class="fas fa-trash-alt nav-icon"> Registro Excluído Com Sucesso!</i>)
                    });
                });
            }
        } catch (error) {
            toast.error("Ocorreu um erro ao tentar excluisr o registro.")       
        }
    }
    
    atualiza = async() => {

        const token    = sessionStorage.getItem('token');
       
        await api.get('/api/comissao', {
            headers: {
                'x-access-token':token,
            }
        }).then(response => {           
            this.setState({
                isListagem: true, 
                isEdicao:false,
                tipo:'',
                tipos: tipos,
                tiposDefault:[],
                pessoa:'',
                pessoas:'',
                pessoasDefault:[],
                servico:'',
                servicos:'',
                servicosDefault:[],
                comissoa:'',
                inicio:'',
                fim:'',                
                items : response.data    
            })
        })
    }

    handleFiltroGrid = async (filterText) => {
        const { filtros, items } = this.state;
        this.Loading(true);
        const filtragem =
          filterText.length > 0
            ? items.filter((item) =>
                (
                  item.id +
                  "" +
                  item.nome 
                )
                  .toLowerCase()
                  .includes(filterText.toLowerCase())
              )
            : filtros;
        this.setState({ items: filtragem, filterText: filterText });
    
        this.Loading(false);
    };
    
    render() {

        const subHeaderComponentMemo = (
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar"
                  onChange={(e) => this.handleFiltroGrid(e.target.value)}
                />
                <div class="input-group-append">
                  <div class="btn btn-primary">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
              </div>
            </div>
          );

        const columns = [
            {
              name: 'Id',
              selector: 'id',
              sortable: true,
            },
            {
              name: 'Tipo',
              selector: 'tipo',
              sortable: true,
              cell: row => row.tipo == 1 ? 'Lavar/Passar' : row.tipo == 2 ? 'Lavar' : 'Passar'
            }, 
            {
                name: 'Pessoa',
                selector: 'funcionario',
                sortable: true,
            },
            {
                name: 'Serviço',
                selector: 'servico',
                sortable: true,
                cell: row => row.servico ? row.servico : 'Qualquer Item'
            },
            {
                name: 'Comissão %',
                selector: 'comissao',
                sortable: true,
                cell: row => row.comissao ? row.comissao.toFixed(2) : 0.00
            },
            {
                name: 'Início',
                selector: 'inicio',
                sortable: true,
                cell: row => row.inicio ? moment( row.inicio ).format("DD/MM/YYYY") : null
            },
            {
                name: 'Fim',
                selector: 'fim',
                sortable: true,
                cell: row => row.fim ? moment( row.fim ).format("DD/MM/YYYY") : null
            },
           
            {
                name: 'Editar',
                selector: 'Editar',
                cell: row =>   <div class="btn-group">
                                  <button id="editar" className="btn btn-default" onClick={ () => { this.edit(row.id)}}><i class="fa fa-edit"></i></button>
                                  <button id="excluir" className="btn btn-danger" onClick={ () => { this.delete(row.id)}}><i class="fas fa-trash-alt"></i></button>                                                           
                              </div>,
                button: true,
            }
        ];
        const {items,isListagem, isEdicao} = this.state;
    
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> CADASTRO COMISSÃO</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => this.atualiza() }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                        
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ isListagem ? "nav-link active" : "nav-link" } id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => this.cancel } href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ isListagem ? true : false }>Listagem</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ isEdicao   ? 'nav-link active' : 'nav-link' } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() => this.add } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={isEdicao ? true : false }>Edição</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={ isListagem ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-listagem-dados" role="tabpanel" aria-labelledby="custom-tabs-listagem-dados-tab">
                                                <DataTable
                                                    title="Listar"
                                                    columns={columns}
                                                    data={items}
                                                    pagination
                                                    subHeader
                                                    subHeaderComponent={subHeaderComponentMemo}
                                                />
                                                <button type="button" onClick={ this.add } className="btn btn-info pull-right">Novo</button>
                                               
                                            </div>
                                            <div className={ isEdicao ? "tab-pane fade show active" : "tab-pane fade"} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <form onSubmit={ this.save }>
                                                    <div className="form-group">
                                                        <label>ID</label>
                                                        <input type="text" className="form-control" name="id" placeholder="ID do Registro" value={ this.state.id } onChange={ e => this.setState({ id: e.target.value})} readOnly/>
                                                    </div>
                                                                                                       
                                                    <div className="form-group">
                                                        <label>Tipo</label>
                                                        <Select
                                                            id="tipo"
                                                            placeholder="Selecione"
                                                            isSearchable="true"
                                                            isOptionSelected 
                                                            value={this.state.tiposDefault}
                                                            options={ this.state.tipos } 
                                                            onChange={ e => this.setState({tipo: e.value, tiposDefault:[{label: e.label, value: e.value }] })}
                                                                                                                                
                                                                                                                 
                                                        />                                                        
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Pessoa</label>
                                                        <Select
                                                            id="pessoa"
                                                            placeholder="Selecione"
                                                            isSearchable="true"
                                                            isOptionSelected     
                                                            value={this.state.pessoasDefault}
                                                            options={ this.state.pessoas } 
                                                            onChange={ e => this.setState({pessoa: e.value, pessoasDefault:[{label: e.label, value: e.value }] })}
                                                                                                                                
                                                        />                                                        
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Serviço</label>
                                                        <Select
                                                            id="servico"
                                                            placeholder="Selecione"
                                                            isSearchable="true"
                                                            isOptionSelected    
                                                            value={this.state.servicoDefault}
                                                            options={ this.state.servicos } 
                                                            onChange={ e => this.setState({servico: e.value, servicoDefault:[{label: e.label, value: e.value }] })}
                                                                                                        
                                                        />                                                        
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Comissão %</label>
                                                        <CurrencyInput
                                                            id="comissao"
                                                            name="input-quantidade"
                                                            className="form-control" 
                                                            placeholder="Informe o valor do serviço"
                                                            defaultValue={ 1.00 }
                                                            decimalsLimit={2}
                                                            value={this.state.comissao ? this.state.comissao : 0.00 }
                                                            onValueChange={(value, name) => this.setState({ comissao: value })}
                                                        />
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Inicio</label>
                                                        <input
                                                            type="date"
                                                            class="form-control"
                                                            placeholder="Previsão de Entrega"
                                                            value={this.state.inicio}
                                                            onChange={(e) =>
                                                                this.setState({ inicio: e.target.value })
                                                            }
                                                        />
                                                    </div>

                                                    <div class="form-group">
                                                        <label>Fim</label>
                                                        <input
                                                            type="date"
                                                            class="form-control"
                                                            placeholder="Previsão de Entrega"
                                                            value={this.state.fim}
                                                            onChange={(e) =>
                                                                this.setState({ fim: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                    
                                                    <button type="submit" className="btn btn-success pull-right">Salvar</button>
                                                    <button type="button" className="btn btn-danger pull-right" onClick={ this.cancel }>Cancelar</button>
                                                </form>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                            </div> 
                            <div className="card-footer">                        
                            </div>
                            <Loading isCarrega={ this.state.isLoading } />
                        </div>
                    </section>
                </div>
            </div>
        )
    }
        
}

export default Comissao;